import {
  CompactDateInput,
  FieldWrapper,
  FilterMultiSelect,
  FilterSearchableSelect,
  FilterSelect,
  FilterSortGroup,
  dateChipLabel,
  formatGroupedValues,
  resolveOptionLabel,
} from "./jobsFilterUtils";

export const JOBS_SHIFTS_ASSIGNMENT_TYPE_OPTIONS = [
  { value: "", label: "All" },
  { value: "Field Staff", label: "Field Staff" },
  { value: "OutSourced Agency", label: "OutSourced Agency" },
];

export const JOBS_SHIFTS_ACTUAL_TIME_STATUS_OPTIONS = [
  { value: "not_submitted", label: "Not Submitted" },
  { value: "as_scheduled", label: "As Scheduled" },
  { value: "different", label: "Different" },
  { value: "no_show", label: "No Show" },
];

export const JOBS_SHIFTS_YES_NO_OPTIONS = [
  { value: "", label: "All" },
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const JOBS_SHIFTS_SORT_OPTIONS = [
  { value: "shift", label: "Shift" },
  { value: "scheduled", label: "Scheduled" },
  { value: "staff_first_name", label: "Staff First Name" },
  { value: "staff_last_name", label: "Staff Last Name" },
  { value: "actuals_submission_status", label: "Actuals Submission Status" },
  { value: "schedule_view", label: "Schedule View" },
];

export function JobsShiftsFilterFields({
  focusedFieldId,
  onFocusClear,
  filters,
  onChange,
  selectedShiftClients = [],
  setSelectedShiftClients,
  selectedShiftClientLocations = [],
  setSelectedShiftClientLocations,
  selectedClientPositions = [],
  setSelectedClientPositions,
  travelTimeValue,
  setTravelTimeValue,
  canReadShiftActual,
  shiftStatusOptions = [],
  shiftsStaffOptions = [],
  staffFilterLoading = false,
  onStaffQueryChange,
  staffSelectedLabel = "",
  shiftsClientOptions = [],
  shiftClientLocationOptions = [],
  shiftsSupervisorOptions = [],
  shiftsOutsourcedAgencyOptions = [],
  shiftsClientPositionOptions = [],
  checkinNoteOptions = [],
  checkInNoteTypeOptions = [],
}) {
  const visibleSortOptions = canReadShiftActual
    ? JOBS_SHIFTS_SORT_OPTIONS
    : JOBS_SHIFTS_SORT_OPTIONS.filter((o) => o.value !== "actuals_submission_status");

  return (
    <>
      <FieldWrapper fieldId="shiftStatus" label="Shift Status" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect id="jobs-shifts-status" options={shiftStatusOptions} value={filters.shiftStatus || []} onChange={(v) => onChange("shiftStatus", v)} placeholder="Select Status" />
      </FieldWrapper>
      <FieldWrapper fieldId="staff" label="Staff" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSearchableSelect
          id="jobs-shifts-staff"
          value={filters.staff || ""}
          selectedLabel={staffSelectedLabel}
          loading={staffFilterLoading}
          onQueryChange={onStaffQueryChange}
          onChange={(v) => onChange("staff", v)}
          options={shiftsStaffOptions.filter((o) => String(o?.value || "") !== "")}
          placeholder="Search staff..."
        />
      </FieldWrapper>
      <FieldWrapper fieldId="clients" label="Client" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect
          id="jobs-shifts-clients"
          options={shiftsClientOptions}
          value={selectedShiftClients}
          onChange={(values) => {
            setSelectedShiftClients(values);
            setSelectedShiftClientLocations([]);
            onChange("clients", values);
            onChange("clientLocations", []);
          }}
          placeholder="Select Clients"
        />
      </FieldWrapper>
      <FieldWrapper fieldId="clientLocations" label="Client Location" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect
          id="jobs-shifts-locations"
          options={shiftClientLocationOptions}
          value={selectedShiftClientLocations}
          onChange={(values) => {
            setSelectedShiftClientLocations(values);
            onChange("clientLocations", values);
          }}
          placeholder={selectedShiftClients.length ? "Select Client Locations" : "Select clients first"}
        />
      </FieldWrapper>
      <FieldWrapper fieldId="shiftSupervisors" label="Shift Supervisor" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect id="jobs-shifts-supervisors" options={shiftsSupervisorOptions} value={filters.shiftSupervisors || []} onChange={(v) => onChange("shiftSupervisors", v)} placeholder="Select Supervisor" />
      </FieldWrapper>
      {canReadShiftActual ? (
        <>
          <FieldWrapper fieldId="actualTimeStatus" label="Actual Time Status" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
            <FilterMultiSelect id="jobs-shifts-actual-status" options={JOBS_SHIFTS_ACTUAL_TIME_STATUS_OPTIONS} value={filters.actualTimeStatus || []} onChange={(v) => onChange("actualTimeStatus", v)} placeholder="Select Actual Time Status" />
          </FieldWrapper>
          <FieldWrapper fieldId="actualTimeConflict" label="Actual Time Conflict" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
            <FilterSelect id="jobs-shifts-actual-conflict" value={filters.actualTimeConflict || ""} onChange={(v) => onChange("actualTimeConflict", v === "all" ? "" : v)} options={JOBS_SHIFTS_YES_NO_OPTIONS} placeholder={null} />
          </FieldWrapper>
        </>
      ) : null}
      <FieldWrapper fieldId="fromDate" label="From Date" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <CompactDateInput
          id="jobs-shifts-from"
          value={filters.fromDate}
          onChange={(newFromDate) => {
            onChange("fromDate", newFromDate);
            if (newFromDate && filters.toDate && newFromDate > filters.toDate) {
              onChange("toDate", "");
            }
          }}
        />
      </FieldWrapper>
      <FieldWrapper fieldId="toDate" label="To Date" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <CompactDateInput id="jobs-shifts-to" value={filters.toDate} onChange={(v) => onChange("toDate", v)} min={filters.fromDate} />
      </FieldWrapper>
      <FieldWrapper fieldId="outsourcedAgency" label="Outsourced Agency" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSelect id="jobs-shifts-outsourced" value={filters.outsourcedAgency || ""} onChange={(v) => onChange("outsourcedAgency", v === "all" ? "" : v)} options={shiftsOutsourcedAgencyOptions} />
      </FieldWrapper>
      <FieldWrapper fieldId="clientPosition" label="Client Position" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect
          id="jobs-shifts-position"
          options={shiftsClientPositionOptions.filter((option) => String(option?.value || "") !== "")}
          value={selectedClientPositions}
          onChange={(values) => {
            setSelectedClientPositions(values);
            onChange("clientPosition", values[0] || "");
          }}
          placeholder="Select Client Positions"
        />
      </FieldWrapper>
      <FieldWrapper fieldId="assignmentType" label="Assignment Type" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSelect id="jobs-shifts-assignment" value={filters.assignmentType || ""} onChange={(v) => onChange("assignmentType", v === "all" ? "" : v)} options={JOBS_SHIFTS_ASSIGNMENT_TYPE_OPTIONS} placeholder={null} />
      </FieldWrapper>
      <FieldWrapper fieldId="travelTime" label="Travel Time" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSelect
          id="jobs-shifts-travel"
          value={travelTimeValue || "all"}
          onChange={(value) => {
            setTravelTimeValue(value);
            onChange("travelTime", { all: "", yes: "yes", no: "no" }[value] || "");
          }}
          options={[{ value: "all", label: "All" }, { value: "yes", label: "Yes" }, { value: "no", label: "No" }]}
          placeholder={null}
        />
      </FieldWrapper>
      <FieldWrapper fieldId="timesheetSignOffDate" label="Timesheet Sign Off Date" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <CompactDateInput id="jobs-shifts-signoff" value={filters.timesheetSignOffDate} onChange={(v) => onChange("timesheetSignOffDate", v)} />
      </FieldWrapper>
      <FieldWrapper fieldId="checkInNote" label="Check In Note" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSelect id="jobs-shifts-checkin-note" value={filters.checkInNote || ""} onChange={(v) => onChange("checkInNote", v === "all" ? "" : v)} options={checkinNoteOptions} placeholder="All notes" />
      </FieldWrapper>
      <FieldWrapper fieldId="checkInNoteType" label="Check In Note Type" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterMultiSelect id="jobs-shifts-checkin-note-type" options={checkInNoteTypeOptions} value={filters.checkInNoteType || []} onChange={(v) => onChange("checkInNoteType", v)} placeholder="Select check-in note type" />
      </FieldWrapper>
      <FieldWrapper fieldId="sort" label="" focusedFieldId={focusedFieldId} onFocusClear={onFocusClear}>
        <FilterSortGroup
          id="jobs-shifts-sort"
          sortBy={filters.sortBy || "scheduled"}
          sortOrder={filters.sortDirection || "asc"}
          onSortByChange={(v) => onChange("sortBy", v)}
          onSortOrderChange={(v) => onChange("sortDirection", v)}
          sortOptions={visibleSortOptions}
        />
      </FieldWrapper>
    </>
  );
}

export function buildJobsShiftsFilterChips({
  filters,
  canReadShiftActual,
  shiftStatusOptions = [],
  shiftsStaffOptions = [],
  shiftsClientOptions = [],
  shiftClientLocationOptions = [],
  shiftsClientLocationOptions = [],
  shiftsSupervisorOptions = [],
  shiftsOutsourcedAgencyOptions = [],
  shiftsClientPositionOptions = [],
  checkinNoteOptions = [],
  checkInNoteTypeOptions = [],
}) {
  const chips = [];
  if ((filters.shiftStatus || []).length) chips.push({ id: "shifts-status", key: "shiftStatus", fieldId: "shiftStatus", label: `Shift Status: ${formatGroupedValues(filters.shiftStatus, (v) => resolveOptionLabel(shiftStatusOptions, v), 3)}` });
  if (filters.fromDate) chips.push({ id: "shifts-from", key: "fromDate", fieldId: "fromDate", label: `From Date: ${dateChipLabel(filters.fromDate)}` });
  if (filters.toDate) chips.push({ id: "shifts-to", key: "toDate", fieldId: "toDate", label: `To Date: ${dateChipLabel(filters.toDate)}` });
  if (filters.staff) chips.push({ id: "shifts-staff", key: "staff", fieldId: "staff", label: `Staff: ${resolveOptionLabel(shiftsStaffOptions, filters.staff)}` });
  if ((filters.clients || []).length) chips.push({ id: "shifts-clients", key: "clients", fieldId: "clients", label: `Clients: ${formatGroupedValues(filters.clients, (v) => resolveOptionLabel(shiftsClientOptions, v), 3)}` });
  else if (filters.client) chips.push({ id: "shifts-client", key: "client", fieldId: "clients", label: `Client: ${resolveOptionLabel(shiftsClientOptions, filters.client)}` });
  if ((filters.clientLocations || []).length) chips.push({ id: "shifts-locations", key: "clientLocations", fieldId: "clientLocations", label: `Client Locations: ${formatGroupedValues(filters.clientLocations, (v) => resolveOptionLabel(shiftClientLocationOptions, v), 3)}` });
  else if (filters.clientLocation) chips.push({ id: "shifts-location", key: "clientLocation", fieldId: "clientLocations", label: `Client Location: ${resolveOptionLabel(shiftsClientLocationOptions, filters.clientLocation)}` });
  if ((filters.shiftSupervisors || []).length) chips.push({ id: "shifts-supervisors", key: "shiftSupervisors", fieldId: "shiftSupervisors", label: `Shift Supervisors: ${formatGroupedValues(filters.shiftSupervisors, (v) => resolveOptionLabel(shiftsSupervisorOptions, v), 3)}` });
  else if (filters.shiftSupervisor) chips.push({ id: "shifts-supervisor", key: "shiftSupervisor", fieldId: "shiftSupervisors", label: `Shift Supervisor: ${resolveOptionLabel(shiftsSupervisorOptions, filters.shiftSupervisor)}` });
  if (canReadShiftActual && (filters.actualTimeStatus || []).length) chips.push({ id: "shifts-actual-status", key: "actualTimeStatus", fieldId: "actualTimeStatus", label: `Actual Time Status: ${formatGroupedValues(filters.actualTimeStatus, (v) => resolveOptionLabel(JOBS_SHIFTS_ACTUAL_TIME_STATUS_OPTIONS, v), 3)}` });
  if (canReadShiftActual && filters.actualTimeConflict) chips.push({ id: "shifts-actual-conflict", key: "actualTimeConflict", fieldId: "actualTimeConflict", label: `Actual Conflict: ${filters.actualTimeConflict}` });
  if (filters.assignmentType) chips.push({ id: "shifts-assignment", key: "assignmentType", fieldId: "assignmentType", label: `Assignment: ${filters.assignmentType}` });
  if (filters.outsourcedAgency) chips.push({ id: "shifts-outsourced", key: "outsourcedAgency", fieldId: "outsourcedAgency", label: `Outsourced Agency: ${resolveOptionLabel(shiftsOutsourcedAgencyOptions, filters.outsourcedAgency)}` });
  if (filters.travelTime) chips.push({ id: "shifts-travel", key: "travelTime", fieldId: "travelTime", label: `Travel Time: ${filters.travelTime}` });
  if (filters.clientPosition) chips.push({ id: "shifts-position", key: "clientPosition", fieldId: "clientPosition", label: `Client Position: ${resolveOptionLabel(shiftsClientPositionOptions, filters.clientPosition)}` });
  if (filters.timesheetSignOffDate) chips.push({ id: "shifts-signoff", key: "timesheetSignOffDate", fieldId: "timesheetSignOffDate", label: `Signoff: ${dateChipLabel(filters.timesheetSignOffDate)}` });
  if (filters.checkInNote) chips.push({ id: "shifts-note", key: "checkInNote", fieldId: "checkInNote", label: `Check In Note: ${resolveOptionLabel(checkinNoteOptions, filters.checkInNote)}` });
  if ((filters.checkInNoteType || []).length) chips.push({ id: "shifts-note-type", key: "checkInNoteType", fieldId: "checkInNoteType", label: `Check In Note Type: ${formatGroupedValues(filters.checkInNoteType, (v) => resolveOptionLabel(checkInNoteTypeOptions, v), 3)}` });
  return chips;
}
